const getEnrichedBundleChildLineItems = ({
  lineItem,
  addOnLabel,
  isReadOnly = true,
  actionLabel,
  actionCallback
}) => [
  ..."bundleChildLineItems" in lineItem && lineItem.bundleChildLineItems ? lineItem.bundleChildLineItems : [],
  ...lineItem.insurance ? [
    {
      title: addOnLabel,
      body: lineItem.insurance.name[0]?.value ?? "",
      price: lineItem.insurance.price?.unit.gross ?? 0,
      sku: lineItem.insurance.sku,
      ...!isReadOnly && actionLabel && actionCallback ? {
        action: {
          text: actionLabel,
          onClick: () => actionCallback(lineItem)
        }
      } : null
    }
  ] : []
];
export {
  getEnrichedBundleChildLineItems
};
//# sourceMappingURL=get-enriched-bundle-child-line-items.js.map
